import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cd7ed46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "taskWrapper mostRecentTask"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Last Task", -1))
const _hoisted_5 = { class: "timer" }
const _hoisted_6 = {
  key: 1,
  class: "taskWrapper mostRecentTask"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Last Task", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "There are no recent active tasks.", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "taskWrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Recent Tasks", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "There are no recent active tasks.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "To See The Most Recent Task You Must Start a Task First.", -1))
const _hoisted_14 = {
  key: 1,
  class: "loading-container"
}

import TaskInline from '@/components/TaskInline.vue';
import TaskInlineMobile from '@/components/TaskInlineMobile.vue';
import TimeSince from '@/components/TimeSince.vue';
import { useTaskStore } from '@/stores/Tasks';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { defineComponent, ref, onUnmounted, computed, onMounted, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const taskStore = useTaskStore();
const employeeStore = useEmployeeStore();
const currentTime = ref(Date.now());

const intervalId = setInterval(() => {
  currentTime.value = Date.now();
}, 1000);

const isMobileView = ref(window.innerWidth < 768);
const updateView = () => {
  isMobileView.value = window.innerWidth < 768;
};


onMounted(() => {
  taskStore.getAllTasks();
  window.addEventListener('resize', updateView);
});

onUnmounted(() => {
  clearInterval(intervalId);
  window.removeEventListener('resize', updateView);
});

const sortedAndAssignedTasks = computed(() => {
  const currentUserID = employeeStore.currentUser?.id;
  return taskStore.sortedTasksByLatestEvent.filter(task =>
    task.assignments?.some(assignment => assignment.user === currentUserID)
  );
});

const mostRecentTask = computed(() => sortedAndAssignedTasks.value[0]);
const otherRecentTasks = computed(() => sortedAndAssignedTasks.value.slice(1, 4));

const formattedTaskDuration = computed(() => {
  const duration = mostRecentTask.value?.total_active_duration;
  if (duration) {
    const durationStr = typeof duration === 'number' ? duration.toString() : duration;
    const durationSeconds = parseDurationToSeconds(durationStr);
    return convertSecondsToHHMMSS(durationSeconds);
  }
  return '00:00:00';
});

function parseDurationToSeconds(durationStr: string): number {
  const parts = durationStr.match(/(\d+):(\d+):(\d+)/);
  if (parts) {
    const hours = parseInt(parts[1], 10);
    const minutes = parseInt(parts[2], 10);
    const seconds = parseInt(parts[3], 10);
    return hours * 3600 + minutes * 60 + seconds;
  }
  return 0;
}

function convertSecondsToHHMMSS(seconds) {
  const pad = (num) => String(num).padStart(2, '0');
  const hours = pad(Math.floor(seconds / 3600));
  const minutes = pad(Math.floor((seconds % 3600) / 60));
  const secs = pad(seconds % 60);
  return `${hours}:${minutes}:${secs}`;
}

const recentevent = computed(() => {
  const lastEvent = mostRecentTask.value?.events.slice(-1)[0]?.event_type || '';
  return lastEvent;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(taskStore).isLoadingTaks)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (mostRecentTask.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_openBlock(), _createBlock(_resolveDynamicComponent(isMobileView.value ? TaskInlineMobile : TaskInline), { task: mostRecentTask.value }, null, 8, ["task"])),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("b", null, [
                    _createVNode(TimeSince, {
                      taskId: mostRecentTask.value.id,
                      duration: formattedTaskDuration.value,
                      eventType: recentevent.value
                    }, null, 8, ["taskId", "duration", "eventType"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            (otherRecentTasks.value.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(otherRecentTasks.value, (task) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: task.id,
                    class: "element"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(isMobileView.value ? TaskInlineMobile : TaskInline), { task: task }, null, 8, ["task"]))
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_12,
                  _hoisted_13
                ], 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14))
  ]))
}
}

})